import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCheckautoCompanyAllList } from '../companyThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'checkautoCompanyAllList';

export const checkautoCompanyAllListSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCheckautoCompanyAllList });
    },
});

export const checkautoCompanyAllList = checkautoCompanyAllListSlice.reducer;
